import React from 'react';
import { Button, TextInput } from '@carbon/react';

const LicensesTab: React.FC = () => (
  <div className="settings-page__panel" style={{ minWidth: 600}}>
    <h3>License keys</h3>
    <div className="settings-page__form-grid">
      <TextInput id="license-computer-name" labelText="Computer name" placeholder="XD-ENCODER-01" />
      <TextInput id="license-computer-key" labelText="Computer key" placeholder="••••-••••-••••-••••" />
      <TextInput id="license-status" labelText="Status" placeholder="Active" />
      <TextInput id="license-type" labelText="Type" placeholder="Production" />
      <TextInput id="license-expiration" labelText="Expiration date" placeholder="2025-12-31" />
      <TextInput id="license-seats" labelText="Seat count" placeholder="4" />
    </div>
  </div>
);

export default LicensesTab;
